module.exports = __webpack_public_path__ + "static/media/23.a30ed9b9.jpeg";